import React from "react";
import styles from "./Termsandpolicy.module.css";
import logo from "../../assets/Images/ATZ2.svg";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>
                <div
                    className={styles.backBtn}
                    onClick={() => navigate("/sign-up")}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="rgb(206 19 119 / 54%)"
                        height="inherit"
                        width="inherit"
                        style={{
                            objectFit: "cover",
                        }}
                        version="1.1"
                        id="Layer_1"
                        viewBox="0 0 512 512"
                    >
                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />

                        <g
                            id="SVGRepo_tracerCarrier"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />

                        <g id="SVGRepo_iconCarrier">
                            {" "}
                            <g>
                                {" "}
                                <g>
                                    {" "}
                                    <path d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M313.749,347.584 c8.341,8.341,8.341,21.824,0,30.165c-4.16,4.16-9.621,6.251-15.083,6.251c-5.461,0-10.923-2.091-15.083-6.251L176.917,271.083 c-8.341-8.341-8.341-21.824,0-30.165l106.667-106.667c8.341-8.341,21.824-8.341,30.165,0s8.341,21.824,0,30.165L222.165,256 L313.749,347.584z" />{" "}
                                </g>{" "}
                            </g>{" "}
                        </g>
                    </svg>
                </div>
                <div className={styles.atzLogoBox}>
                    <div
                        className={styles.logoBox}
                        onClick={() => {
                            navigate("/sign-up");
                        }}
                    >
                        <img src={logo} />
                    </div>
                    <h1 className={styles.mainHeading}>Terms and Conditions</h1>
                </div>
                <div className={styles.paragraphsText}>
                    <h3 className={styles.welcomeText}>Welcome to ATZ.ai!</h3>
                    <p>
                        These terms and conditions outline the rules and regulations for the use of ATZ App's Website, located at atz.ai.
                    </p>
                    <p>
                        By accessing this website we assume you accept these terms and conditions. Do not continue to use atz.ai if you do not agree to take all of the terms and conditions stated on this page.
                    </p>
                    <p>
                        The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements:
                        "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Companyâ€™s terms and conditions.
                        "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves.

                    </p>
                    <p>All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the
                        most appropriate manner for the express purpose of meeting the Clientâ€™s needs in respect of provision of the Companyâ€™s stated services, in
                        accordance with and subject to, prevailing law of Netherlands. Any use of
                        the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.
                    </p>

                    <div className={styles.contentBox}>
                        <h3 className={styles.subHeadingText}>Cookies</h3>
                        <p>
                            We employ the use of cookies. By accessing atz.ai, you agreed to use cookies in agreement with the ATZ App's Privacy Policy.
                        </p>
                        <p>Most interactive websites use cookies to let us retrieve the userâ€™s details for each visit. Cookies are used by our website to enable the functionality
                            of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.</p>
                    </div>
                    <div className={styles.contentBox}>
                        <h3 className={styles.subHeadingText}>License</h3>
                        <p>Unless otherwise stated, ATZ App and/or its licensors own the intellectual property rights for all material on
                            atz.ai. All intellectual property rights are reserved. You may access this from atz.ai for your own personal
                            use subjected to restrictions set in these terms and conditions.
                        </p>

                        <p>You must not:<br />
                            <ul className={styles.listText}>
                                <li>
                                    Republish material from atz.ai
                                </li>
                                <li>Sell, rent or sub-license material from atz.ai</li>
                                <li>Reproduce, duplicate or copy material from atz.ai</li>
                                <li>Redistribute content from atz.ai</li>
                            </ul>
                        </p>
                        <p>This Agreement shall begin on the date hereof. Our Terms and Conditions were created with the help of the{' '}
                            <a href='https://www.termsandconditionsgenerator.com/'>Terms And Conditions Generator</a> and the{' '}
                            <a href='https://www.generateprivacypolicy.com/'>Privacy Policy Generator.</a>
                        </p>
                        <p>
                            Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. ATZ App does not filter, edit,
                            publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of ATZ App,its agents and/or affiliates. Comments
                            reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, ATZ App shall not be liable for the Comments
                            or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.
                        </p>
                        <p>
                            ATZ App reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate,
                            offensive or causes breach of these Terms and Conditions.
                        </p>
                        <p>You warrant and represent that:<br />
                            <ul className={styles.listText}>
                                <li>
                                    You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;
                                </li>
                                <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</li>
                                <li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy
                                </li>
                                <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li>
                            </ul>
                        </p>
                        <p>
                            You hereby grant ATZ App a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your
                            Comments in any and all forms, formats or media.
                        </p>
                    </div>


                    <div className={styles.contentBox}>
                        <h3 className={styles.subHeadingText}>Hyperlinking to our Content
                        </h3>

                        <p>The following organizations may link to our Website without prior written approval:<br />
                            <ul className={styles.listText}>
                                <li>
                                    Government agencies;
                                </li>
                                <li>Search engines;</li>
                                <li>News organizations;</li>
                                <li>Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and</li>
                                <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.
                                </li>
                            </ul>
                        </p>
                        <p>These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive;
                            (b) does not falsely imply sponsorship,
                            endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking partyâ€™s site.
                        </p>

                        <p>We may consider and approve other link requests from the following types of organizations:<br />
                            <ul className={styles.listText}>
                                <li>
                                    commonly-known consumer and/or business information sources;
                                </li>
                                <li>dot.com community sites;</li>
                                <li>associations or other groups representing charities;</li>
                                <li>online directory distributors;</li>
                                <li>internet portals;</li>
                                <li>accounting, law and consulting firms; and</li>
                                <li>educational institutions and trade associations.</li>
                            </ul>
                        </p>
                        <p>
                            We will approve link requests from these organizations if we decide that:<br /> (a) the link would not make us look unfavorably to ourselves or to our accredited businesses;<br />
                            (b) the organization does not have any negative records with us;<br />
                            (c) the benefit to us from the visibility of the hyperlink compensates the absence of ATZ App; and<br /> (d) the link is in the context of general resource information.
                        </p>
                        <p>These organizations may link to our home page so long as the link:<br /> (a) is not in any way deceptive;<br /> (b) does not falsely imply sponsorship, endorsement or approval
                            of the linking party and its products or services; and<br /> (c) fits within the context of the linking partyâ€™s site.</p>

                        <p>
                            If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail
                            to ATZ App. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you
                            intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.
                        </p>

                        <p>Approved organizations may hyperlink to our Website as follows:<br />
                            <ul className={styles.listText}>
                                <li>
                                    By use of our corporate name; or
                                </li>
                                <li>By use of the uniform resource locator being linked to; or</li>
                                <li>By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking partyâ€™s site.</li>

                            </ul>
                        </p>
                        <p>No use of ATZ App's logo or other artwork will be allowed for linking absent a trademark license agreement.</p>
                    </div>


                    <div className={styles.contentBox}>
                        <h3 className={styles.subHeadingText}>iFrames</h3>
                        <p>
                            Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.
                        </p>
                    </div>
                    <div className={styles.contentBox}>
                        <h3 className={styles.subHeadingText}>Content Liability</h3>
                        <p>
                            We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that
                            is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes,
                            otherwise violates, or advocates the infringement or other violation of, any third party rights.
                        </p>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default TermsOfService;
